<template>
    <v-btn
        class="btn-odds black--text font-weight-bold odds-width multiline-btn text-center"
        small
        :class="{ 'white lighten-2': didMutate }"
        :color="typeColor[type]"
        tile
        depressed
        v-bind="$attrs"
        v-on="$listeners"
        @click="btnOddsClicked"
    >
        <span v-mutate="onMutate">
            <slot />
        </span>
    </v-btn>
</template>
<script>
import { mapState } from "vuex"
import round from "lodash/round"
import subtract from "lodash/subtract"
import multiply from "lodash/multiply"
export default {
    name: "BtnOdds",
    props: {
        type: { type: String, default: "lay", required: true }
    },
    data: () => ({
        didMutate: false,
        typeColor: {
            back: "secondary",
            lay: "accent"
        },
        winning: 0,
        stake: "",
        odds: "",
        minBet: 100,
        maxBetAmt: 1000,
        // refresh: true,
        maxMarketAmount: 10000,
        isBtnOddsClicked: false
    }),
    computed: {
        ...mapState({
            bettingMarket: (state) => state.placeBet.market,
            bettingRunner: (state) => state.placeBet.runner,
            bettingAllRunners: (state) => state.placeBet.allRunners,
            bettingType: (state) => state.placeBet.bettingType,
            runs: (state) => state.placeBet.runs,
            matchIds: (state) => state.placeBet.matchIds,
            userConfig: (state) => state.settings.userConfig,
            minMaxMarket: (state) => state.matchInside.minMaxMarket
        })
    },
    watch: {
        minMaxMarket() {
            if (this.isBtnOddsClicked) {
                if (
                    this.userConfig.oneClickActiveStake <
                    this.minMaxMarket.minBet
                ) {
                    this.$store.commit("snackbar/open", {
                        text: `Minimum bet should be greater than ${this.minMaxMarket.minBet}`,
                        color: "error"
                    })
                } else if (
                    this.userConfig.oneClickActiveStake >
                    this.minMaxMarket.maxBet
                ) {
                    this.$store.commit("snackbar/open", {
                        text: `Maximum bet should be less than ${this.minMaxMarket.maxBet}`,
                        color: "error"
                    })
                } else {
                    this.placeBet()
                }
                this.isBtnOddsClicked = false
            }
        }
    },
    methods: {
        disableCheck() {
            if (!this.$auth.loggedIn) {
                return true
            }
            if (
                this.bettingType === "default" &&
                this.userConfig &&
                this.userConfig.oneClickStatus
            ) {
                return true
            } else {
                return false
            }
        },
        onMutate() {
            this.didMutate = true
            setTimeout(() => {
                this.didMutate = false
            }, 300)
        },
        async btnOddsClicked() {
            if (!this.$auth.loggedIn) {
                this.$router.push({
                    path: "/login",
                    query: { redirectUrl: this.$route.path }
                })
                return
            }
            this.$listeners.betData()
            if (
                this.$auth.loggedIn &&
                this.userConfig &&
                this.userConfig.oneClickStatus &&
                (this.bettingType === "default" ||
                    this.bettingType === "lineLadder" ||
                    this.bettingType === "premiumsports")
            ) {
                if (!this.userConfig) {
                    await this.$store.dispatch("settings/getUserConfig")
                }
                if (this.bettingMarket) {
                    if (
                        this.bettingType === "default" ||
                        this.bettingType === "bookmaker"
                    ) {
                        if (this.bettingMarket.maxMarketAmount) {
                            this.maxMarketAmount =
                                this.bettingMarket.maxMarketAmount
                        }
                    }
                }
                this.odds = this.$store.state.placeBet.odds
                this.position = this.$store.state.placeBet.oddsIndex
                this.stake = this.userConfig.oneClickActiveStake
                this.calculateWinnings()
                this.isBtnOddsClicked = true
            }
        },
        calculateWinnings() {
            if (this.stake > 0 && this.odds > 0) {
                let odds = this.odds
                if (
                    this.bettingType === "bookmaker" ||
                    this.bettingType === "fancy" ||
                    this.bettingType === "lineLadder"
                ) {
                    odds = odds / 100 + 1
                }
                const m = multiply(parseFloat(odds), parseFloat(this.stake))
                const s = subtract(m, parseFloat(this.stake))
                this.winning = round(s, 2)
            }
        },
        async placeBet() {
            if (this.$store.state.placeBet.loading) {
                this.$store.commit("snackbar/open", {
                    text: "Please wait! Processing previous bet...",
                    color: "error"
                })
                return ""
            }
            try {
                let watingSeconds
                const setBettingType = this.bettingType
                if (this.bettingType === "fancy") {
                    watingSeconds = this.bettingRunner.betDelay || 1
                } else if (this.bettingType === "bookmaker") {
                    watingSeconds = this.bettingMarket.betDelay
                } else if (this.bettingType === "lineLadder") {
                    watingSeconds = this.bettingMarket.betDelay + 1
                } else {
                    watingSeconds = this.bettingMarket.betDelay || 1
                }
                this.$store.dispatch("betLoading/begin", {
                    seconds: watingSeconds,
                    bettingType: setBettingType
                })
                await Promise.all([
                    this.$store.dispatch("placeBet/execute", {
                        market: this.bettingMarket,
                        runner: this.bettingRunner,
                        odds: this.odds,
                        oddsIndex: this.position,
                        runs: this.runs,
                        stake: this.stake,
                        type: this.type,
                        winning: this.winning
                        // ip: this.$store.state.ip.value
                    })
                ])
                this.$store.dispatch("betLoading/close")
                if (this.$store.state.placeBet.error) {
                    this.$store.commit("snackbar/open", {
                        text: this.$store.state.placeBet.error,
                        color: "error"
                    })
                    if (this.$store.state.placeBet.error === "Access Denied") {
                        this.$store.dispatch("user/logout")
                    }
                } else if (
                    (this.$store.state.placeBet.success &&
                        this.$store.state.placeBet.success.status !==
                            "UNMATCHED" &&
                        this.$store.state.placeBet.success.message) ||
                    this.$store.state.placeBet.success ===
                        "Bet Placed Successfully"
                ) {
                    this.$store.commit("placeBet/reset_popover")
                    this.$store.commit("snackbar/open", {
                        text:
                            this.$store.state.placeBet.success.message ||
                            this.$store.state.placeBet.success,
                        color: "success"
                    })
                    // let betbooksCategory = 'betBooks/getAll'
                    // if (
                    //   this.$route.name === 'sportsbook-category-subCategory-id' ||
                    //   this.$route.name === 'sportsbook-category-subCategory-id-betradar'
                    // ) {
                    //   betbooksCategory = 'betBooks/get'
                    // }
                    // // console.log(this.matchIds)
                    // await Promise.all([
                    //   this.$store.dispatch(
                    //     betbooksCategory,
                    //     this.matchIds,
                    //     this.refresh === false
                    //   ),
                    //   this.$store.dispatch('openBets/getMyCurrentBetStatus', false)
                    // ])
                } else if (
                    this.$store.state.placeBet.success?.status ===
                        "UNMATCHED" &&
                    this.$store.state.placeBet.success?.message
                ) {
                    this.$store.commit("snackbar/open", {
                        text: this.$store.state.placeBet.success.message,
                        color: "error"
                    })
                } else {
                    this.$store.commit("snackbar/open", {
                        text: this.$store.state.placeBet.success,
                        color: "success"
                    })
                }
            } catch (error) {}
        }
    }
}
</script>
<style lang="scss">
.multiline-btn {
    letter-spacing: 0px;
    font-size: 12px;
    @media screen and (max-width: 600px) {
        font-size: 12px;
    }
    @media screen and (max-width: 320px) {
        font-size: 11px;
    }
}
.sportsbook {
    .btn-odds {
        @media screen and (max-width: 1024px) {
            min-width: 50px !important;
        }
    }
}
.market-block {
    .btn-odds {
        @media screen and (max-width: 320px) {
            min-width: 60px !important;
        }
    }
}
.bet-detail-view {
    .market-block {
        .odds-category {
            .right-side-button.v-overlay {
                width: calc(60px * 6 + 0.75rem) !important;
                &.fancy-odds {
                    width: calc(58px * 4 + 0.75rem) !important;
                    @media screen and (max-width: 1024px) {
                        width: calc(48px * 4 + 0.75rem) !important;
                    }
                    @media screen and (max-width: 912px) {
                        width: calc(58px * 4 + 0.75rem) !important;
                    }
                    @media screen and (max-width: 601px) {
                        width: calc(58px * 1.9 + 0.75rem) !important;
                    }
                    @media screen and (max-width: 320px) {
                        width: calc(51px * 1.9 + 0.75rem) !important;
                    }
                    &.dual-mode {
                        width: calc(52px * 2.1 + 0.75rem) !important;
                        @media screen and (max-width: 1024px) {
                            width: calc(50px * 2.2 + 0.75rem) !important;
                        }
                    }
                }
                @media screen and (max-width: 1024px) {
                    width: calc(50px * 6 + 0.75rem) !important;
                }
                @media screen and (max-width: 912px) {
                    width: calc(72px * 5 + 0.75rem) !important;
                }
                @media screen and (max-width: 599px) {
                    width: calc(60px * 1.9 + 0.75rem) !important;
                }
                @media screen and (max-width: 320px) {
                    width: calc(51px * 1.9 + 0.75rem) !important;
                }
            }
        }
        .btn-odds {
            min-width: 60px !important;
            @media screen and (max-width: 1024px) {
                min-width: 50px !important;
            }
            @media screen and (max-width: 912px) {
                min-width: 60px !important;
            }
            @media screen and (max-width: 320px) {
                min-width: 53px !important;
            }
        }
    }
}
.premium-cricket-tab {
    .bet-detail-view {
        .market-block {
            .odds-category {
                .right-side-button.v-overlay {
                    width: calc(60px * 6 + 0.75rem) !important;
                }
            }
        }
    }
}
.btn-odds {
    height: calc(100% - 0.4rem) !important;
    padding: 0 !important;
    min-width: 60px !important;
    @media screen and (max-width: 1024px) {
        min-width: 60px !important;
    }
    @media screen and (max-width: 991px) {
        min-width: 60px !important;
    }
    @media screen and (max-width: 600px) {
        min-width: 60px !important;
    }
    @media screen and (max-width: 320px) {
        min-width: 53px !important;
    }
    span.d-block {
        font-weight: 800 !important;
    }
    span.mini-rate {
        font-weight: normal !important;
    }
}
.btn-odds {
    + .btn-odds {
        margin-left: 2px;
    }
}
</style>
